import styled from "styled-components"
import RowSolicitudCompra from './rowSolicitudCompra.jsx'


const Container=styled.div`
	display:flex;
	flex-wrap:wrap;	
	justify-content:space-around;
	align-items:center;
	color:white;
	
`;

const ContainerSolicitud=styled.div`
	height:70px;
	width:96vw;
	margin:10px;
	transition:all 110ms;
	&:hover{
		scale:1.02
	}
`;



export default function SolicitudesCompra(props){
	let { solicitudes,setOpenState } = props;

	let openBackdrop=(ele)=>{
		setOpenState(ele)
	}


	return(
		<Container>
			{solicitudes?
	 				solicitudes.map(solicitud=>
	 							<ContainerSolicitud>
	 												<RowSolicitudCompra  key={solicitud.id} compra={solicitud} openBackdrop={openBackdrop} />

	 							</ContainerSolicitud> ):
	 				<div>no data</div>   }
		</Container>
	)
}